import { render, staticRenderFns } from "./BlankContent.vue?vue&type=template&id=7a0daa7d&scoped=true"
import script from "./BlankContent.vue?vue&type=script&lang=js"
export * from "./BlankContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0daa7d",
  null
  
)

export default component.exports